import React from 'react';
import PropTypes from 'prop-types';
import SMORoomEditBaseFragment from './SMORoomEditBaseFragment';
import SMRoomHelper from 'components/helpers/SMRoomHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMConst from 'lib/SMConst';
import SMFormTextFieldWithError from 'components/dashboard/form/SMFormTextFieldWithError';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMOBusinessDayView from './SMOBusinessDayView';
import SMOAcademyLinkBaloonView from 'components/dashboard/owners/SMOAcademyLinkBaloonView';
import SMFormCheckBoxWithError from 'components/dashboard/form/SMFormCheckBoxWithError';
import SMOBusinessHoursView from './SMOBusinessHoursView';

class SMORoomEditBasicFragment extends SMORoomEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      room: this.props.room,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      room : nextProps.room,
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }

  stayCertificationFileHasChanged(e) {
    let files = e.target.files;
    if (files[0] == null) return;

    this.fileFieldDidChangeValue(e);
  }

  allowRentTypesHasChanged(e) {
    let target = e.currentTarget;
    if (target.checked) {
      this.checkBoxDidChangeValue(e);
      return;
    }

    let room = this.state.room;
    if (room.rent_type == target.value || room.plans.some(function(plan) { return plan.rent_type == target.value; })) {
      e.preventDefault();
      window.alert('この利用形態が選択されているプランが既に存在します。先にそちらを削除してください。');
      return;
    }

    this.checkBoxDidChangeValue(e);
  }

  render() {
    let daytimeAllowed = SMRoomHelper.isAllowedRentType(this.state.room, SMConst.RentType.DayTime);
    let stayAllowed = SMRoomHelper.isAllowedRentType(this.state.room, SMConst.RentType.Stay);

    let transitionName = 'js-list-fade-animation';
    let transitionEnterTimeout = 500;
    let transitionLeaveTimeout = 0;
    let transitionConditionKey = 'transition-both';
    if (daytimeAllowed && !stayAllowed) {
      transitionConditionKey = 'transition-daytime-only';
    } else if (!daytimeAllowed && stayAllowed) {
      transitionConditionKey = 'transition-stay-only';
    }

    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>スペースの見出し
          <span className="dashboard-title__supplement ml15">
            64文字以内。未入力時は会場名と同じ「{this.props.space.name}」を表示します。
          </span>
        </h2>
        <SMFormTextFieldWithError name="name" 
          value={this.state.room.name} 
          errorText={SMFormatHelper.errorText('Room', 'name', this.props.errors)}
          placeholderText="スペースマーケット、渋谷ビル等" 
          options={{className:'w500'}}
          delegate={this} />

        <SMFormFieldTitle title='利用形態'
          subTitle='利用形態を選択してください。宿泊の場合は貸出タイプも選択してください。'
          isRequired={true} />
        <div className="form-box">
          <input
            type="checkbox" name='allow_rent_types[]' id='allow_rent_type_daytime' value={SMConst.RentType.DayTime}
            defaultChecked={daytimeAllowed} onChange={this.allowRentTypesHasChanged.bind(this)} />
          <label htmlFor="allow_rent_type_daytime" key="rent_type[][0]-label" className="form-checkbox">時間・１日レンタル</label><br />
          <input
            type="checkbox" name='allow_rent_types[]' id='allow_rent_type_stay' value={SMConst.RentType.Stay}
            defaultChecked={stayAllowed} onChange={this.allowRentTypesHasChanged.bind(this)} />
          <label htmlFor="allow_rent_type_stay" key="rent_type[][1]-label" className="form-checkbox">宿泊</label>

          {this.renderStayRoomTypeForm(stayAllowed)}
          <SMFormValidationMessage name='allow_rent_types' errorText={SMFormatHelper.errorText('Room', 'allow_rent_types', this.props.errors)} />
        </div>
        <CSSTransitionGroup transitionName={transitionName} transitionEnterTimeout={transitionEnterTimeout} transitionLeaveTimeout={transitionLeaveTimeout}>
          <div key={transitionConditionKey}>
            {this.renderStayCertificationForm(stayAllowed)}

            <div className="of-h">
              <div className="w300 fl">
                <SMFormFieldTitle title='床面積'
                  subTitle='半角数字のみ。'
                  isRequired={true} />
                <div className='form-box'>
                  <SMFormTextField name="area"
                    value={this.state.room.area}
                    options={{className:'w110'}}
                    delegate={this} /> ㎡
                  <SMFormValidationMessage name="area" errorText={SMFormatHelper.errorText('Room', 'area', this.props.errors)} />
                </div>
              </div>

              <SMFormFieldTitle title='収容人数'
                subTitle='半角数字のみ。'
                isRequired={true} />

              {this.renderCapacityForm(daytimeAllowed, stayAllowed)}
            </div>

            {this.renderEventTypeForm(daytimeAllowed)}

            <SMFormFieldTitle title='アメニティ'
              subTitle='この会場で提供可能なアメニティをすべて選択してください。複数選択可能。'
              isRequired={false} />

            {this.renderAmenityForm(stayAllowed)}

            <SMFormFieldTitle title='貸出可能な曜日'
              ref='businessDays'
              subTitle='ゲストが予約可能な曜日にチェックを入れてください。'
              isRequired={true} />

            <input type='hidden' name='business_days[]' value='' />
            <SMOBusinessDayView model={this.state.room} delegate={this} />

            {this.renderBusinessHoursForm(daytimeAllowed)}
            {this.renderCheckinCheckoutForm(stayAllowed)}
          </div>
        </CSSTransitionGroup>

        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.didSelectNextFragment.bind(this)}>次へ</a>
        </div>
        <SMOAcademyLinkBaloonView displayPlace={SMConst.AcademyLinkDisplayPlace.RoomBasic} isCurrent={this.state.isCurrent} />
      </div>
    );
  }

  renderStayRoomTypeForm (stayAllowed) {
    let stayRoomTypes = [
      { label: 'シェアルーム', value: SMConst.StayRoomType.SharedRoom, checked: (this.state.room.stay_room_type == SMConst.StayRoomType.SharedRoom) },
      { label: '個室', value: SMConst.StayRoomType.PrivateRoom, checked: (this.state.room.stay_room_type == SMConst.StayRoomType.PrivateRoom) },
      { label: 'まるまる貸切', value: SMConst.StayRoomType.EntirePlace, checked: (this.state.room.stay_room_type == SMConst.StayRoomType.EntirePlace) }
    ];

    return stayRoomTypes.map(function(stayRoomType) {
      let value = stayRoomType.value;
      let id = 'stay_room_type_' + value;
      let checked = value == this.state.room.stay_room_type;

      return [
        <input type='radio' name='stay_room_type' key={id} id={id} value={value} defaultChecked={checked} onChange={this.radioButtonDidChangeValue.bind(this)} disabled={!stayAllowed} />,
          <label htmlFor={id} key={id + '-label'} className='form-radio'>{stayRoomType.label}</label>
      ];
    }, this);
  }

  renderStayCertificationForm (stayAllowed) {
    if (!stayAllowed) return;

    return [
      <SMFormFieldTitle
        key='title'
        title='旅館業許可証'
        subTitle='宿泊利用時に必要です。記載事項が分かる写真、またはPDFファイルをアップロードしてください。'
        isRequired={true}
      />,
      <div key='form' className="form-box">
        <input type='file' name='stay_certification' id='stay_certification' onChange={this.stayCertificationFileHasChanged.bind(this)} hidden />
        {this.state.room.has_stay_certification ? [
          <input key='input' type='button' disabled='disabled' className="button-disabled pt13 pb13 w180 mr10" value='アップロード済み' />,
          <span key='span'>{this.state.room.stay_certification.name}</span>,
          <a href='#' key='a' className='link-hover-border ml10' onClick={function(e) { e.preventDefault(); $('#stay_certification').click(); }} >
            {I18n.t('dashboard.label_000117')}
          </a>,
        ] : (
          <label htmlFor='stay_certification' className='button-gray pt13 pb13 w180 mr10'>
            <i className="fa fa-paperclip"></i>
            &nbsp;{I18n.t('dashboard.label_000055')}
          </label>
        )}
        <SMFormValidationMessage name='stay_certification' errorText={SMFormatHelper.errorText('Room', 'stay_certification', this.props.errors)} />
      </div>
    ];
  }

  renderCapacityForm (daytimeAllowed, stayAllowed) {
    let capacityForms = [];
    if (daytimeAllowed) {
      capacityForms.push(
        <span className='mr20' key='daytimeCapacity'>
          時間・1日レンタル
          <SMFormTextField name="capacity"
            value={this.state.room.capacity}
            options={{className:'w70 mr5 ml5', disabled: !daytimeAllowed}}
            delegate={this} /> 人
        </span>
      );
    }

    if (stayAllowed) {
      capacityForms.push(
        <span key='stay' className='mr20'>
          宿泊
          <SMFormTextField name="stay_capacity"
            value={this.state.room.stay_capacity}
            options={{className:'w70 mr5 ml5', disabled: !stayAllowed}}
            delegate={this} /> 人
        </span>
      );
    }

    return (
      <div className='form-box'>
        {capacityForms}
        <SMFormValidationMessage name="capacity" errorText={SMFormatHelper.errorText('Room', 'capacity', this.props.errors)} />
        <SMFormValidationMessage name="stay_capacity" errorText={SMFormatHelper.errorText('Room', 'stay_capacity', this.props.errors)} />
      </div>
    );
  }

  renderEventTypeForm (daytimeAllowed) {
    if (!daytimeAllowed) return;

    let eventTypes = this.props.eventTypes.map(function(eventType) {
      let checked = this.state.room.event_types.some(function(selectedEventType) {
        return eventType.attributes.name == selectedEventType.name;
      });

      return {
        label: eventType.attributes.name_text,
        value: eventType.attributes.name,
        checked: checked,
      };
    }, this);

    return [
      <SMFormFieldTitle 
        key='title'
        title='使用用途'
        subTitle='このスペースをどのような目的に使ってよいか選択してください。複数選択可能。'
        isRequired={true}
      />,
      <SMFormCheckBoxWithError
        key='error'
        name="event_type[]"
        errorText={SMFormatHelper.errorText('Room', 'event_type', this.props.errors)}
        options={{className:'w200'}}
        items={eventTypes}
        delegate={this}
      />
    ];
  }

  renderAmenityForm (stayAllowed) {
    let amenities = [];
    let stayAmenities = [];

    this.props.amenities.forEach(function(amenity) {
      let checked = false;
      if (this.props.room.amenity) {
        checked = this.props.room.amenity.indexOf(amenity.attributes.name) != -1;
      }

      let processedAmenity = {
        label: amenity.attributes.name_text,
        value: amenity.attributes.name,
        checked: checked
      };

      if (amenity.attributes.amenity_type == SMConst.AmenityType.All || amenity.attributes.amenity_type == SMConst.AmenityType.Rental) {
        amenities.push(processedAmenity);
      } else if (amenity.attributes.amenity_type == SMConst.AmenityType.Stay) {
        stayAmenities.push(processedAmenity);
      }
    }, this);

    let amenityRenderer = function(enabled, offset, amenity, index) {
      let id = 'amenities[][' + (index + offset) + ']';
      return [
        <input type='checkbox' id={id} key={id} name='amenities[]' value={amenity.value} disabled={!enabled} defaultChecked={amenity.checked} onChange={this.checkBoxDidChangeValue.bind(this)} />,
        <label htmlFor={id} key={id + '-label'} className='form-checkbox w180'>{amenity.label}</label>
      ];
    };
    let amenityForms = [];
    amenityForms.push(amenities.map(amenityRenderer.bind(this, true, 0)));
    if (stayAllowed) {
      amenityForms.push(<h3 className='dashboard-title2 mt10 mb5' key='amenity-stay-title'>宿泊専用</h3>);
      amenityForms.push(<span key='span'>{stayAmenities.map(amenityRenderer.bind(this, stayAllowed, amenities.length))}</span>);
    }

    return (
      <div className='form-box'>
        {amenityForms}
      </div>
    );
  }

  renderBusinessHoursForm (daytimeAllowed) {
    if (!daytimeAllowed) return;

    return [
      <SMFormFieldTitle 
        key='0'
        title='貸出可能な時間帯'
        subTitle='時間・1日レンタル時に、ゲストが予約可能な時間帯を1時間単位、0時〜36時（翌日12時）の間で入力してください。半角数字のみ。'
        isRequired={true}
      />,
    <SMOBusinessHoursView key='1' model={this.state.room} delegate={this} errors={this.props.errors} />,
    ];
  }

  renderCheckinCheckoutForm (stayAllowed) {
    if (!stayAllowed) return;

    return [
      <SMFormFieldTitle 
        key='0'
        title='チェックイン・チェックアウト時間'
        ref='checkInOutTime'
        subTitle='宿泊利用時に、チェックイン可能な時間帯とチェックアウト時間を1時間単位、0時〜36時の間で入力してください。半角数字のみ。'
        isRequired={stayAllowed}
      />,
      <div key='1' className='form-box'>
        チェックイン&nbsp;
        <SMFormTextField name='stay_checkin_start_hour'
          value={this.state.room.stay_checkin_start_hour}
          options={{className:'form-text w40'}}
          placeholderText='15'
          delegate={this} />&nbsp;:00
        <span className="ml5 mr5">〜</span>
        <SMFormTextField name='stay_checkin_end_hour'
          value={this.state.room.stay_checkin_end_hour}
          options={{className:'form-text w40'}}
          placeholderText='23'
          delegate={this} />&nbsp;:00
        <span className='ml50'>
          チェックアウト&nbsp;
          <SMFormTextField name='stay_checkout_hour'
            value={this.state.room.stay_checkout_hour}
            options={{className:'form-text w40'}}
            placeholderText='10'
            delegate={this} />&nbsp;:00
        </span>
        <SMFormValidationMessage name="stay_checkin_start_hour" errorText={SMFormatHelper.errorText('Room', 'stay_checkin_start_hour', this.props.errors)} />
        <SMFormValidationMessage name="stay_checkin_end_hour" errorText={SMFormatHelper.errorText('Room', 'stay_checkin_end_hour', this.props.errors)} />
        <SMFormValidationMessage name="stay_checkout_hour" errorText={SMFormatHelper.errorText('Room', 'stay_checkout_hour', this.props.errors)} />
      </div>,
    ];
  }
}
SMORoomEditBasicFragment.propTypes = {
  eventTypes: PropTypes.array.isRequired,
  amenities: PropTypes.array.isRequired,
};
SMORoomEditBasicFragment.defaultProps = {
  errors: [],
};
export default SMORoomEditBasicFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditBasicFragment.jsx